<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Perubahan template WA`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <p class="m-d-0 f-16 f-c-black f-regular">
                        Semua perubahan yang anda lakukan belum tersimpan dan akan hilang. Yakin ingin keluar?
                    </p>
                </div>
            </template>
            <template v-slot:modal-footer
                ><div class="">
                    <div>
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Ya, keluar'"
                            :id="`confirm-leave`"
                            @action="leave"
                        />
                    </div>
                    <div>
                        <SOButton :outline="true" :full="true" :text="'Batal'" :id="'batal-leave'" @action="back" />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "ConfirmLeave",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat.daftar_oulet.edit_template",
            modalId: "confirm-leave",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    methods: {
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        leave() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
            });
        },
    },
};
</script>
